import axios from "axios";
import { unwrapApiResponse } from "./response.js";

function getBaseURL(baseURLKey) {
  if (!baseURLKey || baseURLKey === "DEFAULT") {
    return import.meta.env.VITE_API_BASE_URL;
  }

  return (
    import.meta.env[`VITE_API_BASE_URL_${baseURLKey}`] ||
    import.meta.env.VITE_API_BASE_URL
  );
}

const http = axios.create({
  timeout: 15000,
});

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  const baseURLKey = config.baseURLKey;

  config.baseURL = config.baseURL || getBaseURL(baseURLKey);
  config.headers["platform"] = "h5";

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  delete config.baseURLKey;

  return config;
});

http.interceptors.response.use(
  (response) => unwrapApiResponse(response.data),
  (error) => {
    // 请求层只规范错误消息，不直接弹 Toast，避免页面 catch 再提示时出现重复提示。
    error.message =
      error.response?.data?.message || error.message || "请求失败";
    return Promise.reject(error);
  },
);

export function request(config) {
  return http.request(config);
}

export default http;
